import { classNames } from "../../../utils/classNames"

type Props = {
    className?: string
    children: React.ReactNode
}

/** For rendering error text below form fields. */
export const FormError = (props: Props) => {
    return <div className={classNames(classes.error, props.className)}>{props.children}</div>
}

const classes = {
    error: "pt-0.5 text-[13px] text-red-500",
}
